import {
    Directive,
    HostListener,
    Input,
    Output,
    EventEmitter
  } from '@angular/core';
  import * as dateFns from 'date-fns';
/**
 * Change the view date to the next view. For example:
 * 
 * ```typescript
 * <button
 *  appCalendarNextView
 *  [(viewDate)]="viewDate"
 *  [view]="view">
 *  Next
 * </button>
 * ```
 */
export class CalendarNextViewDirective {
/**
 * The current view
 */
view: string;
/**
 * The current view date
 */
viewDate: Date;
/**
 * Called when the view date is changed
 */
viewDateChange: EventEmitter<Date> = new EventEmitter();
/**
 * @hidden
 * @return {?}
 */
onClick(): void {
      const /** @type {?} */ addFn: any = {
        day: dateFns.addDays,
        week: dateFns.addWeeks,
        month: dateFns.addMonths,
        schedule: dateFns.addDays,
        year: dateFns.addYears
      }[this.view];

      this.viewDateChange.emit(addFn(this.viewDate, 1));
    }
  static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[appCalendarNextView]'
  }, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'view': [{ type: Input },],
'viewDate': [{ type: Input },],
'viewDateChange': [{ type: Output },],
'onClick': [{ type: HostListener, args: ['click', ] },],
};
}

function CalendarNextViewDirective_tsickle_Closure_declarations() {
/** @type {?} */
CalendarNextViewDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarNextViewDirective.ctorParameters;
/** @type {?} */
CalendarNextViewDirective.propDecorators;
/**
 * The current view
 * @type {?}
 */
CalendarNextViewDirective.prototype.view;
/**
 * The current view date
 * @type {?}
 */
CalendarNextViewDirective.prototype.viewDate;
/**
 * Called when the view date is changed
 * @type {?}
 */
CalendarNextViewDirective.prototype.viewDateChange;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
